"use strict";
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
    return __assign.apply(this, arguments);
  };
var __read =
  (this && this.__read) ||
  function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o),
      r,
      ar = [],
      e;
    try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    } catch (error) {
      e = { error: error };
    } finally {
      try {
        if (r && !r.done && (m = i["return"])) m.call(i);
      } finally {
        if (e) throw e.error;
      }
    }
    return ar;
  };
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEnvToDomain = exports.getBaseAppUrl = exports.getAppUrl = exports.getApps = exports.getDomainLevel = exports.addQueries = exports.stringifyQuery = exports.getUrlQueries = void 0;
/** Returns an object representing the query parameters for a given url */
function getUrlQueries(search) {
  var _a, _b;
  search =
    (_b =
      search !== null && search !== void 0
        ? search
        : (_a = globalThis.location) === null || _a === void 0
        ? void 0
        : _a.href) !== null && _b !== void 0
      ? _b
      : "";
  return search
    .slice(1)
    .split("&")
    .reduce(function (mapping, query) {
      if (query) {
        var _a = __read(query.split("="), 2),
          key = _a[0],
          value = _a[1];
        mapping[key] = decodeURIComponent(value);
      }
      return mapping;
    }, {});
}
exports.getUrlQueries = getUrlQueries;
/** Converts an object with query parameters into a search string */
function stringifyQuery(obj) {
  var query = Object.entries(obj)
    .filter(function (entry) {
      var _a = __read(entry, 2),
        _key = _a[0],
        val = _a[1];
      return val !== "" && val !== null && val !== undefined;
    })
    .map(function (_a) {
      var _b = __read(_a, 2),
        key = _b[0],
        val = _b[1];
      return key + "=" + encodeURIComponent(val);
    })
    .join("&");
  return query.length > 0 ? "?" + query : "";
}
exports.stringifyQuery = stringifyQuery;
/** It adds new query parameters to a URL */
function addQueries(url, obj) {
  var _a = __read(url.split("?"), 2),
    path = _a[0],
    _b = _a[1],
    queries = _b === void 0 ? "" : _b;
  return path + stringifyQuery(__assign(__assign({}, getUrlQueries("?" + queries)), obj));
}
exports.addQueries = addQueries;
function getDomainLevel(level, host) {
  var _a;
  return (
    host ||
    ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _a === void 0
      ? void 0
      : _a.hostname)
  )
    .split(".")
    .slice(-1 * level)
    .join(".");
}
exports.getDomainLevel = getDomainLevel;
var getApps = function (host) {
  var _a, _b;
  var domain = host || getDomainLevel(2);
  var hostname = (_a = globalThis.location) === null || _a === void 0 ? void 0 : _a.hostname;
  var nachoBase = "http://".concat(
    hostname === "localhost"
      ? "localhost:10091"
      : (_b = globalThis.location) === null || _b === void 0
      ? void 0
      : _b.host,
  );
  return {
    accounts: { dev: "http://localhost:10004", domain: "accounts.".concat(domain) },
    go: { dev: "http://localhost:10005", domain: "go.".concat(domain) },
    myCompany: { dev: "http://localhost:10008", domain: "company.".concat(domain) },
    dashboard: { dev: "".concat(nachoBase, "/dashboard.html#"), domain: "dashboard.".concat(domain) },
    report: { dev: "".concat(nachoBase, "/report.html#"), domain: "report.".concat(domain) },
    open: { dev: "".concat(nachoBase, "/open.html#"), domain: "open.".concat(domain) },
    gogetter: { dev: "".concat(nachoBase, "/gogetter.html#"), domain: "gogetter.".concat(domain) },
    haydayApp: { dev: "".concat(nachoBase, "/app.html#"), domain: "app.".concat(domain) },
  };
};
exports.getApps = getApps;
/** Returns a url to another PINATA app under the same environment */
var getAppUrl = function (env) {
  if (env === void 0) {
    env = "development";
  }
  return function (host) {
    return function (app, path, query) {
      if (path === void 0) {
        path = "";
      }
      if (query === void 0) {
        query = {};
      }
      var base = (0, exports.getBaseAppUrl)(env)(host)(app);
      var queryStr = stringifyQuery(__assign({ useStagingEnv: getUrlQueries().useStagingEnv }, query));
      return base + "/" + path + queryStr;
    };
  };
};
exports.getAppUrl = getAppUrl;
/** Returns the root url to a PINATA app under the same environment  */
var getBaseAppUrl = function (env) {
  return function (host) {
    return function (app) {
      var apps = (0, exports.getApps)(host);
      if (env === "development") {
        return apps[app].dev;
      } else {
        return "https://" + (0, exports.addEnvToDomain)(env)(apps[app].domain, host);
      }
    };
  };
};
exports.getBaseAppUrl = getBaseAppUrl;
/** Adds an environment's domain to an app's domain */
var addEnvToDomain = function (environment) {
  return function (domain, host) {
    if (environment.toLowerCase() === "production") {
      return domain;
    }
    var partialDomain = getDomainLevel(2, host);
    return domain.replace(".".concat(partialDomain), "-".concat(environment, ".").concat(partialDomain));
  };
};
exports.addEnvToDomain = addEnvToDomain;
